<template>
  <div>
    <v-row>
      <v-col md="8">
        <v-card >
          <StatisticArticleTable></StatisticArticleTable>
        </v-card>
      </v-col>
      <v-col>
        <v-card md="auto">
         <StatisticArticleOverviewCard></StatisticArticleOverviewCard>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import StatisticArticleTable from "@/pages/admin/components/statistic/articles/table/statisticArticleTable"
import StatisticArticleOverviewCard from "@/pages/admin/components/statistic/articles/card/statisticArticleOverviewCard"
export default {
  components:{
    StatisticArticleTable,
    StatisticArticleOverviewCard
  }
}
</script>